/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_AssigneeInputs */

const en_filter_has_assignee = /** @type {(inputs: Filter_Has_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an assignee`)
};

const de_filter_has_assignee = /** @type {(inputs: Filter_Has_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuständige`)
};

/**
* | output |
* | --- |
* | "an assignee" |
*
* @param {Filter_Has_AssigneeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_assignee = /** @type {((inputs?: Filter_Has_AssigneeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_AssigneeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_assignee(inputs)
	return en_filter_has_assignee(inputs)
});